import { useLocale } from "next-intl";
import React from "react";

const Price = ({ amount = null, currency = null, className = "" } = {}) => {
  const locale = useLocale();
  if (!currency) {
    return null;
  }
  if (amount === null) {
    return <>-</>;
  }
  if (Number.isNaN(amount)) {
    return <span>{`${currency} ???`} </span>;
  }

  return (
    <span className={className}>
      {new Intl.NumberFormat(`${locale}-CH`, {
        style: "currency",
        currency,
      }).format(amount / 100)}
    </span>
  );
};

export default Price;
